/**
 * @param loanRepository {ReturnType<import('core/data-model/loan/repository').createLoanRepository>}
 */
export function createLoanDocumentListService(loanRepository) {
  const _getFinancialDocument = async (listFinancialTable) => {
    return await listFinancialTable()
  }

  const getFinancialDocument = () => {
    return _getFinancialDocument(loanRepository.listFinancialTable)
  }

  const _getHealthCheckItem = async (listHealthCheckTable) => {
    return await listHealthCheckTable()
  }

  const getHealthCheckItem = () => {
    return _getHealthCheckItem(loanRepository.listHealthCheckTable)
  }

  return {
    _getFinancialDocument,
    getFinancialDocument,
    _getHealthCheckItem,
    getHealthCheckItem,
  }
}
